import style from '../styles/searchPagestyle.module.css';
import '../../index.css';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import { motion } from 'framer-motion';

// import Swiper core and required modules
import SwiperCore, { Navigation } from 'swiper';
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';
import ToolTip from '../components/tooltip/toolTip-component';

import CarouselCompo2 from '../components/carousel2/carousel2-component';
import { Carousel } from '@mantine/carousel';
import { useEffect, useState } from 'react';
import { createStyles, Stack, ScrollArea } from '@mantine/core';
import { FooterCompo } from '../components';
import searchProperty from '../../data/Search_Property.json';
import SearchBoxV2Component from '../components/searchbox/searchboxv2-component';
import SuggestCityComponent from '../components/suggestCity/suggestcity-component';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRecommendationProperty, recommendationPropertiesStore, recommendationPropertyIsEmpty, recommendationPropertyPush } from '../store/reducers/recommendationPropertySlice';
import { Link, useNavigate } from 'react-router-dom';
import { fetchProperties, propertySearchPush, setPropertySearch } from '../store/reducers/propertySearchSlice';
import Swal from 'sweetalert2';
import capitalizeWord from '../utility/capitalizeWord';

// install Swiper modules
SwiperCore.use([Navigation]);
const useStyle = createStyles((theme) => ({
  container: {
    '@media (max-width: 600px)': {
      paddingLeft: '0!important ',
    },
    searchBoxWrapper: {
      maxWidth: 300,
    },
  },
}));

const SearchPage = () => {
  const categories = searchProperty.masterPropertyCategories;
  const invesments = searchProperty.masterInvesments;

  const [selectedCategories, setselectedCategories] = useState(null);
  const [selectedInvestmens, setselectedInvestmens] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const { classes } = useStyle();

  const properties = useSelector(recommendationPropertiesStore);

  const recommendationPropertyEmpty = useSelector(recommendationPropertyIsEmpty)

  function handleLimitCategory(category) {
    if (selectedCategories?.includes(category)) {
      const list = selectedCategories??[];
      const idx = list.indexOf(category);
      list.splice(idx, 1);
      console.log(list)
      setselectedCategories(list);
    } else {
      const list = selectedCategories ? [...selectedCategories, category] : [category];
      if (list.length > 5) {
        list.shift();
      }
      setselectedCategories(list);
    }
    // const a = document.getElementsByName('chk');
    // let newvar = 0;
    // let count;
    // for (count = 0; count < a.length; count++) {
    //   if (a[count].checked === true) {
    //     newvar = newvar + 1;
    //   }
    //   if (newvar > 5) {
    //     Swal.fire({
    //       title: 'Error!',
    //       text: 'Maksimal pilih 5 item',
    //       icon: 'error',
    //       confirmButtonText: 'Ok',
    //     });
    //     return false;
    //   }
    // }
  }
  
  function handleLimitJenis(invest) {
    setselectedInvestmens(invest);
    // if (selectedInvestmens?.includes(invest)) {
    //   const list = selectedInvestmens??[];
    //   const index = list.indexOf(invest);
    //   list.splice(index, 1);
    //   setselectedInvestmens(list);
    // } else {
    //   const list = selectedInvestmens? [...selectedInvestmens, invest] : [invest];
    //   setselectedInvestmens(list);
    // }
  }

  useEffect(() => {
    if(recommendationPropertyEmpty){
      (async function fetch() {
        dispatch(await fetchRecommendationProperty())
      })()
    }
  }, [properties, dispatch, recommendationPropertyEmpty])

  async function searchProperties() {
    try {
      if (selectedInvestmens?.length > 0 && selectedCategories?.length > 0) {
        dispatch(await fetchProperties(selectedCity ?? 'jember', selectedInvestmens, selectedCategories));
        navigate(`/hasil-pencarian?city=${selectedCity??'jember'}&transaction=${selectedInvestmens.toLowerCase()}&categories=${selectedCategories.map(category => category.name).join(',').toLowerCase()}`);
      } else {
        Swal.fire({
          title: 'Error!',
          text: 'Silahkan Pilih Properti dan Jenis Properti',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      }
    } catch (error) {
      console.log(error)
      .catch(err => {
        return Swal.fire({
          title: 'Error!',
          text: 'Silahkan Pilih Properti dan Jenis Properti dengan valid!',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      });
    }
  }
  

  return (
    <motion.div
      initial={{ width: 0 }}
      animate={{ width: '100%' }}
      exit={{ x: window.innerWidth, transition: { duration: 1 } }}
    >
      {/* Jumbotron Section */}
      <div className={`${style.jumbotron} jumbotron-fluid`}>
        <div className={`${style['input-container']} input-container`}>
          <div className={`container ${classes.searchBoxWrapper}`}>
            {/* <SearchBoxCompo /> */}
            <SearchBoxV2Component setSelectedCity={setSelectedCity} />
            <SuggestCityComponent suggestion={[]} />
          </div>
        </div>
      </div>
      {/* End Jumbotron */}

      {/* Main Section */}
      <main>
        <div className={`${style['container-fluid']} mb-5`}>
          <div className="row">
            {/* Pilih Properti Section */}
            <div
              className={`${style.rincianProperti} col-12 col-md-0 col-lg-11 p-0  mb-3 mt-4`}
            >
              <div
                className={`${style.pProperti} d-flex flex-row align-items-center mb-2`}
              >
                <h1>Pilih Properti</h1>
                <ToolTip message={'Maksimal hanya bisa memilih 5'} />
              </div>
              {/* Checkbox Button */}
              <div className="button-check"></div>
              {/* End Checkbox Button */}
              <div className={style.tombolPilih}>
                <div className={`${style.pilihProperti} ${style.selectpicker}`}>
                  <div className={`${style['form-check']} me-2`}>
                    {categories &&
                      categories.map((category, key) => (
                        <div key={key}>
                          <label
                            className="form-check-label"
                            htmlFor={category.name}
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={category.name}
                              // {...(selectedCategories && selectedCategories?.includes(category) ? 'checked': null)}
                              checked={selectedCategories && selectedCategories?.includes(category)}
                              id={category.name}
                              name="chk"
                              onClick={() => handleLimitCategory(category)}
                            />
                            <span>
                              {capitalizeWord(category.name)}
                            </span>
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
                <div
                className={`${style.pProperti} d-flex flex-row align-items-center mt-4 mb-2`}
              >
                <h1>Jenis Properti</h1>
                <ToolTip message={'Minimal memilih 1 Jenis Properti'} />
                </div>
                <div
                  className={`${style.pilihProperti} ${style.jenisProperti} mb-3`}
                >
                  <div className={style['form-check']}>
                    {invesments &&
                      invesments.map((invest, key) => (
                        <>
                          <div key={key}>
                            <label
                              className="form-check-label"
                              htmlFor={invest}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={invest}
                                id={invest}
                              {...(selectedInvestmens && selectedInvestmens?.includes(invest) ? 'checked': '')}
                                onClick={() => handleLimitJenis(invest)}
                              />
                              <span>
                                {invest[0].toUpperCase() + invest.substring(1)}
                              </span>
                            </label>
                          </div>
                        </>
                      ))}
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className={`btn ${style['btn-submit']} btn-success mt-4 rounded-pill`} onClick={async () => await searchProperties()}
              >
                <p className="m-0">Cari Properti</p>
              </button>
            </div>
            {/* End Pilihan Properti */}

            <div
              className={`${style.perumahanLn} ${style['rincian-6']} col-12 col-md-0 col-lg-12 p-0  mt-3`}
            >
              <h1>Rekomendasi Properti</h1>
              <Carousel
                controlsOffset="10%"
                controlSize={40}
                slideSize={350}
                slideGap={30}
                align="start"
                pl={250}
                // classNames={{
                //   container: classes.container,
                //   control: classes.control,
                // }}
                className={classes.container}
                styles={{
                  control: {
                    '&[data-inactive]': {
                      opacity: 0.5,
                      cursor: 'default',
                    },
                  },
                }}
              >
                {properties?.map((item, key) => {
                  return (
                    <Link to={`/properti?id=${item.id}`} key={key}>
                    <CarouselCompo2
                      image={item.images[0]}
                      title={item.name}
                      address={`${item.address.street}, ${item.address.lower_city[0].toUpperCase() + item.address.lower_city.substring(1)}`}
                    />
                    </Link>
                  );
                })}
              </Carousel>
            </div>
          </div>
        </div>
        <JumboTron2 />
      </main>
      {/* End Main */}
      <FooterCompo />
    </motion.div>
  );
};

export default SearchPage;
